import { FC, PropsWithChildren, ReactNode } from "react";
import { Group as MantineGroup, GroupProps as MantineGroupProps } from "@mantine/core";

export interface GroupProps extends MantineGroupProps {
  className?: string;
  children?: ReactNode;
}

const Group: FC<PropsWithChildren<GroupProps>> = (props) => {
  const { className, children } = props;
  return (
    <MantineGroup className={`${className ? className : ""}`} {...props}>
      {children}
    </MantineGroup>
  );
};

export default Group;
